import { z } from 'zod';

export const SecurityTrackingShape = () => {
	return z.object({
		trackedSecurities: z.array(z.string()).optional(),
	});
};

export type SecurityTrackingFormDto = z.infer<ReturnType<typeof SecurityTrackingShape>>;
